import { GetServerSideProps, InferGetServerSidePropsType, NextPage } from 'next';
import { NextSeo } from 'next-seo';
import { Fragment } from 'react';

import { Content } from '@/components/templatePage/content';
import { Header } from '@/components/templatePage/header';
import { Layout } from '@/components/ui/shared/layouts/Layout/Layout';
import { accessFrom } from '@/constants/custom-request-headers';
import { AccessFrom } from '@/enums/AccessFrom';
import { generateStore } from '@/utils/generateStore';

const About: NextPage<InferGetServerSidePropsType<typeof getServerSideProps>> = ({ accessFromLocation }) => {
  return (
    <Fragment>
      <NextSeo
        title="About"
        openGraph={{
          url: `${process.env.NEXT_PUBLIC_BASE_URL}/about`,
        }}
      />
      <Layout accessFrom={accessFromLocation}>
        <Header title="About us" />
        <Content>
          <p>
            We are the world’s first repository platform for cutting-edge scientific lectures, research, discussion and
            conference live-streaming. Introducing an online video platform custom built for scientific and academic
            events. We aggregate and host conference content in both a live and virtual environment, allowing presenters
            to reach new global audiences while also giving conference attendees the ability to watch any content they
            might have missed.
          </p>
          <p>
            We are enriching lectures with transcriptions, real-time language translations, DOI numbers, MARC records,
            slides, PowerPoint presentations.
          </p>
          <p>
            <strong>You can cite the lecture.</strong>
          </p>
          <p>
            <strong>You can share it.</strong>
          </p>
          <p>
            <strong>You can search.</strong>
          </p>
          <p>
            <strong>You can connect with the speaker.</strong>
          </p>
          <p>
            <strong>You can start a collaboration.</strong>
          </p>
          <p>
            We have decades of experience in scientific and academic publishing, conference management, content
            creation, and an Emmy Award-winning production team.
          </p>
          <p>
            <em>
              Our Mission is to digitize scientific knowledge through video, making it globally accessible and useful by
              enriching, preserving and aggregating conference content. Science is a global discipline, and we all need
              to be unified. We all need to work together now towards an open society and connected world. We need to
              build bridges, not barriers. Underline Science is part of that global bridge.
            </em>
          </p>
          <p>
            <em>
              Alex Lazinica
              <br />
              Underline Science
              <br />
              CEO
            </em>
          </p>
        </Content>
      </Layout>
    </Fragment>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const store = generateStore({ context });

  return {
    props: {
      fallback: store.fallback,
      accessFromLocation: context.res.getHeader(accessFrom) || AccessFrom.Core,
    },
  };
};

export default About;
